/**
 * 訪客信用卡單次刷卡的 3D 驗證來回。
 *
 * 付款頁把客戶導去銀行驗證頁；驗證完 TapPay 帶回固定的 /pay/3ds-result（後端 result_url 不能帶
 * 自訂 query，帶了 TapPay 不送後端通知），TapPay 會附上 order_number（＝platform_order_id）。
 * 以防萬一另外在 sessionStorage 記一份單號；付款憑證（pt）本來就由 payLink.ts 依單號存著，
 * 導回 /pay/{單號} 就能以付款連結模式接著看結果（交易確認中 → 輪詢到已付款或失敗）。
 */

const KEY = "pay_3ds_order";
const TTL_MS = 30 * 60 * 1000;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const THREE_DS_RESULT_PATH = "/pay/3ds-result";

export const rememberThreeDsOrder = (orderId: string): void => {
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ orderId, exp: Date.now() + TTL_MS }));
  } catch {
    // sessionStorage 不可用：只靠 TapPay 帶回的 order_number
  }
};

const readStoredOrder = (): string | null => {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as { orderId?: unknown; exp?: unknown };
    if (typeof parsed.orderId !== "string" || typeof parsed.exp !== "number" || Date.now() >= parsed.exp) return null;
    return parsed.orderId;
  } catch {
    return null;
  }
};

/** 3D 驗證回來要導去的付款頁；單號不像 platform_order_id 就回 null（不導去任意路徑）。 */
export const resolveThreeDsReturnPath = (search: string): string | null => {
  const fromQuery = (new URLSearchParams(search).get("order_number") ?? "").trim();
  const orderId = fromQuery || readStoredOrder();
  return orderId && UUID_RE.test(orderId) ? `/pay/${orderId}` : null;
};
